var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileblackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.672,
    height: 42.09,
    viewBox: "0 0 33.672 42.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_2_",
    "data-name": "user (2)",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M14.522,14A10.522,10.522,0,0,0,4,24.522a6.313,6.313,0,0,0,6.313,6.313H31.358a6.313,6.313,0,0,0,6.313-6.313A10.523,10.523,0,0,0,27.149,14Z",
    transform: "translate(0 13.254)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M17.522,2A10.522,10.522,0,1,0,28.045,12.522,10.522,10.522,0,0,0,17.522,2Z",
    transform: "translate(3.313)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileblackIcon);
export default __webpack_public_path__ + "static/media/profileblack_icon.a10b9dd03470ff4b43827d1673ad0430.svg";
export { ForwardRef as ReactComponent };